import { render, staticRenderFns } from "./setupPlanRubetek.vue?vue&type=template&id=d3c0b61e&scoped=true"
import script from "./setupPlanRubetek.vue?vue&type=script&lang=js"
export * from "./setupPlanRubetek.vue?vue&type=script&lang=js"
import style0 from "./setupPlanRubetek.vue?vue&type=style&index=0&id=d3c0b61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c0b61e",
  null
  
)

export default component.exports